import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import { contentfulMediaType, contentfulRichTextType } from 'types';
import getContentfulImgixUrl from 'utils/getContentfulImgixUrl';
import Flex from 'legacy/components/flex';
import Box from 'legacy/components/box';
import Text from 'legacy/components/text';
import Image from 'legacy/components/image';
import SimpleRichText from 'legacy/components/humanity-v1/primitives/simpleRichText';

const renderOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <Text mt={0} color="blue">
        {children}
      </Text>
    ),
  },
};

/**
 *
 * @deprecated
 */
const ValuePropWithImage = ({ image, heading, content }) => (
  <Flex flexWrap="wrap" mx={[0, null, -3]} textAlign={['center', null, 'left']}>
    <Box width={[1, null, 'auto']} px={[0, null, 3]}>
      <Image src={getContentfulImgixUrl(image.url)} width={80} height={80} lazyload />
    </Box>
    <Box width={[1, null, 340]} px={[0, null, 3]}>
      {!!heading?.length && (
        <Text mt={0} color="blue" fontWeight={700}>
          {heading}
        </Text>
      )}
      <SimpleRichText content={content?.json} renderOptions={renderOptions} />
    </Box>
  </Flex>
);

ValuePropWithImage.propTypes = {
  image: contentfulMediaType.isRequired,
  heading: PropTypes.string,
  content: contentfulRichTextType.isRequired,
};

ValuePropWithImage.defaultProps = {
  heading: '',
};

export default ValuePropWithImage;
